<div class="whitespace-normal">
  <p class="mb-1 font-normal text-xs sm: text-gray-600">Cập nhật {{book.updatedAt ? (book.updatedAt | date :'dd/MM/yyyy HH:mm') : 'Unknown Date'}}</p>
</div>